<template>
    <div class="call-button-holder" v-if="$UIPrivilege('dispatching', 'voip_phone')">
        <img src="/traveller-ui/static/traveller/img/call.png" :class="callButtonClass" @click="call" alt="call"/>
    </div>
</template>

<script>
import phone from '@/store/dispatching/phone';

export default {
    name: 'CallButton',
    props: ['recipient'],
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
    },
    mounted() {
        this.$store.dispatch('phone/getPhonebook');
    },
    computed: {
        callButtonClass() {
            if (this.isEnabled()) {
                return 'call-button enabled';
            }
            return 'call-button disabled';
        },
        //TODO: Should we also add a tooltip text for why the call might not be possible?
    },
    methods: {
        isEnabled() {
            let phoneAvailable = false;

            switch (this.$store.state.phone.phoneState.status) {
                case 'connected':
                case 'registered':
                case 'group_call_setup':
                case 'call_ended':
                case 'call_error':
                    phoneAvailable = true;
                    break;
                case 'unconfigured':
                case 'disconnected':
                case 'unregistered':
                case 'calling':
                case 'call_connected':
            }

            // Check whether "at least one" recipient is online according to the phonebook.
            let recipientOnline = false;
            if (this.recipient) {
                let list = [];
                if (Array.isArray(this.recipient)) {
                    list = this.recipient;
                } else {
                    list.push(this.recipient);
                }
                for (const sipId of list) {
                    let sipClient = this.$store.state.phone.phonebook[sipId];
                    if (sipClient && sipClient.status == 'online') {
                        recipientOnline = true;
                        break;
                    }
                }
            }
            return phoneAvailable && recipientOnline;
        },
        call() {
            if (this.isEnabled()) {
                //TODO: If this same CallButton will be used for group calls also, add a check for which one this is and another request for group calls.
                this.$store.commit('phone/requestIndividualCall', this.recipient);
            }
        }
    }
}
</script>

<style lang="scss">
.call-button-holder {
    width: 51px;
    height: 33px;
    display: inline-block;
    margin-right: 1px;

    .call-button {
        height: 100%;
    }

    .call-button.enabled {
        cursor: pointer;
    }

    .call-button.disabled {
            filter: grayscale(100%);
    }
}
</style>